import React, { Component } from 'react';
import GoogleMap from '../google-map-component/google-map';
import './travel-calculator.scss';

export class TravelCalculator extends Component {
  constructor(props) {
    super(props);

    this.state = {
      start: '',
      destination: '',
      numberOfStudents: '',
      modeOfTransportation: 'DRIVING',
      travelModifier: "0.02875", // when updated for the new year, change the travelModifer here
      perStudentAllocation:'$0.00',
      totalAllocation: '$0.00',
      formErrors: {
        start: '',
        destination: '',
        numberOfStudents: '',
        travelModifier: '',
      },
      startValid: false,
      destinationValid: false,
      numberOfStudentsValid: false,
      travelModifierValid: false,
      formValid: false
    };

    this.map = React.createRef();
  }

  handleUserInput = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({ [name]: value }, () => {
      this.validateField(name, value);
    });
  }

  validateField(fieldName, value) {
    let formValidationErrors = this.state.formErrors;

    let startValid = this.state.startValid;
    let destinationValid = this.state.destinationValid;
    let numberOfStudentsValid = this.state.numberOfStudentsValid;
    let travelModifierValid = this.state.travelModifierValid;

    switch (fieldName) {
      case 'start':
        startValid = value.length > 3;
        formValidationErrors.start = startValid ? '' : ' is too short';
        break;
      case 'destination':
        destinationValid = value.length > 3;
        formValidationErrors.destination = destinationValid ? '' : ' is too short';
        break;
      case 'numberOfStudents':
        numberOfStudentsValid = this.isNumber(value);
        formValidationErrors.numberOfStudents = numberOfStudentsValid ? '' : ' must be a whole number';
        break;
      default:
        break;
    }

    this.setState({
      formErrors: formValidationErrors,
      startValid: startValid,
      destinationValid: destinationValid,
      numberOfStudentsValid: numberOfStudentsValid
    }, this.validateForm);
  }

  isNumber(num) {
    return Number.isInteger(+num);
  }

  isValidModifier(num) {
    if (Number.isFinite(+num) && +num % 1 !== 0) {
      return 0 < +num && +num < 1;
    }
  }

  validateForm() {
    this.setState({ formValid: this.state.startValid && this.state.destinationValid && this.state.numberOfStudentsValid });
  }

  errorClass(error) {
    return error.length === 0 ? '' : 'has-error';
  }

  handleOptionChange = (e) => {
    this.setState( { modeOfTransportation: e.target.value } );
  }

  handleSubmit = (e) => {
    const start = this.state.start;
    const destination = this.state.destination;
    const modeOfTransportation = this.state.modeOfTransportation;
    const numberOfStudents = +this.state.numberOfStudents;

    const map = this.map.current;
    map.updateMap(start, destination, modeOfTransportation);

    e.preventDefault();
  }

  calculateAllocations = distance => {
    const roundTripDist = distance * 2; // in meters
    const distanceInMiles = ((roundTripDist / 1000) / 1.609).toFixed(2); // in miles

    let maxPerStudentAllocation = 75;

    let perStudentAllocation = +this.state.travelModifier * distanceInMiles
    if (perStudentAllocation > maxPerStudentAllocation) {
      perStudentAllocation = maxPerStudentAllocation;
    }

    const totalAllocation = perStudentAllocation * this.state.numberOfStudents;

    this.setState({
      perStudentAllocation: `\$${perStudentAllocation.toFixed(2)}`,
      totalAllocation: `\$${totalAllocation.toFixed(2)}`
    });
  }

  render() {
    return (
      <div className="travel-calculator-container">
        <div className="inputs">
          <div className="header-container">
            <div className="header">SGA Travel Calculator</div>
          </div>

          <form className="travel-calculator-form-container">
            <div className={`form-group ${this.errorClass(this.state.formErrors.start)}`}>
              <div className="form-control">
                <label htmlFor="start">From</label>
                <input required className={`${this.errorClass(this.state.formErrors.start)}`} type="text" name="start" placeholder="Georgia Tech"
                  value={this.state.start} onChange={this.handleUserInput} />
              </div>
            </div>

            <div className={`form-group ${this.errorClass(this.state.formErrors.destination)}`}>
              <div className="form-control">
                <label htmlFor="destination">To</label>
                <input required className={`${this.errorClass(this.state.formErrors.destination)}`} type="text" name="destination" placeholder="Destination"
                  value={this.state.destination} onChange={this.handleUserInput} />
              </div>
            </div>

            <div className={`form-group ${this.errorClass(this.state.formErrors.numberOfStudents)}`}>
              <div className="form-control">
                <label htmlFor="numberOfStudents">Number of Students</label>
                <input required className={`${this.errorClass(this.state.formErrors.numberOfStudents)}`} type="text" name="numberOfStudents" placeholder="1"
                  value={this.state.numberOfStudents} onChange={this.handleUserInput} />
              </div>
            </div>

            <div className="btn-container">
              <button type="submit" className="btn btn-primary"
                disabled={!this.state.formValid}
                onClick={this.handleSubmit}>Calculate Cost</button>
            </div>
          </form>
        </div>

        <div className="outputs">
          <div className="output-fields">
            <div className="field-control" id="first">
              <label htmlFor="perStudentAllocation">Per Student Allocation</label>
              <input className="output" name="perStudentAllocation" readOnly value={this.state.perStudentAllocation} />
            </div>

            <div className="field-control">
              <label htmlFor="totalAllocation">Total Allocation</label>
              <input className="output" name="totalAllocation" readOnly value={this.state.totalAllocation} />
            </div>
          </div>

          <GoogleMap
            ref={this.map}
            options={{
              center: { lat: 33.7756222, lng: -84.398479 },
              zoom: 14,
              disableDefaultUI: true,
            }}
            onMapLoad={map => {
              const marker = new window.google.maps.Marker({
                position: { lat: 33.7756222, lng: -84.398479 },
                map: map,
                title: 'Hello Gech!'
              });
            }}
            calculateAllocations={this.calculateAllocations}
          />
        </div>

      </div>
    );
  }
}

export default TravelCalculator;